import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { ApiService } from 'app/services'

export const authGuard: CanActivateFn = (route, state) => {
  const apiService = inject(ApiService)
  const router = inject(Router)

  if (!apiService.isAuthenticated) {
    router.navigate(['login'])
    return false
  }

  return true
}
